var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0934 11.9334C16.04 11.9334 15.96 11.9334 15.8934 11.9334C14.4934 11.8801 13.3867 10.7467 13.3867 9.3334C13.3867 7.8934 14.5467 6.7334 15.9867 6.7334C17.4267 6.7334 18.5867 7.90673 18.5867 9.3334C18.6001 10.7467 17.4934 11.8934 16.0934 11.9334Z",
    fill: "#096DD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 15.9468C10.5601 17.1334 10.5601 19.0668 12.3334 20.2534C14.3468 21.6001 17.6534 21.6001 19.6668 20.2534C21.4401 19.0668 21.4401 17.1334 19.6668 15.9468C17.6534 14.6134 14.3601 14.6134 12.3334 15.9468Z",
    fill: "#096DD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 2.66699H8C5.78667 2.66699 4 4.44033 4 6.62699V21.1737C4 23.3603 5.78667 25.1337 8 25.1337H9.01334C10.08 25.1337 11.0933 25.547 11.84 26.2937L14.12 28.547C15.16 29.5737 16.8533 29.5737 17.8933 28.547L20.1733 26.2937C20.92 25.547 21.9467 25.1337 23 25.1337H24C26.2133 25.1337 28 23.3603 28 21.1737V6.62699C28 4.44033 26.2133 2.66699 24 2.66699ZM16 6.73366C17.44 6.73366 18.6 7.90699 18.6 9.33366C18.6 10.747 17.48 11.8803 16.0933 11.9337C16.04 11.9337 15.96 11.9337 15.8933 11.9337C14.4933 11.8803 13.3867 10.747 13.3867 9.33366C13.4 7.90699 14.56 6.73366 16 6.73366ZM19.6667 20.2537C17.6533 21.6003 14.3467 21.6003 12.3333 20.2537C10.56 19.0803 10.56 17.1337 12.3333 15.947C14.36 14.6003 17.6667 14.6003 19.6667 15.947C21.44 17.1337 21.44 19.067 19.6667 20.2537Z",
    fill: "#096DD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagUser);
export default __webpack_public_path__ + "static/media/tag_user.7c84643f6d6868f97002bb0518397b42.svg";
export { ForwardRef as ReactComponent };